import { CodeBase } from "./_codeBase";

/**
 * 変更区分
 */
export class SectionType extends CodeBase<SectionType>
{
    /** 変更区分 "00", "" */
    public static readonly NONE: SectionType = new SectionType("00", "");
    /** 変更区分 "01", "追加" */
    public static readonly ADDED: SectionType = new SectionType("01", "追加");
    /** 変更区分 "02", "変更" */
    public static readonly EDITED: SectionType = new SectionType("02", "変更");

    /**
     * 
     * @param value
     * @param text
     */
    protected constructor(value: any, text: string, abbr?: any) {
        super(value, text, abbr);
    }

    /**
     * 
     */
    public static List(): SectionType[] {
        return [
            SectionType.NONE,
            SectionType.ADDED,
            SectionType.EDITED,
        ];
    }
}
